import { type z } from 'zod'
import { idSchemaV2, isId } from '../ids'
import { isNotDefined } from '../../util/isEmpty'

export const NotificationIdSchema = idSchemaV2('Notification')
export type NotificationId = z.infer<typeof NotificationIdSchema>
export const isNotificationId = isId(NotificationIdSchema)

export const NOTIFICATION_ID_MAX_CREATED_AT_MS = 36 ** 9 - 1

export function notificationIdTimestamp(createdAtMs: number): string {
  if (!Number.isSafeInteger(createdAtMs) || createdAtMs < 0 || createdAtMs > NOTIFICATION_ID_MAX_CREATED_AT_MS) {
    throw new RangeError('Notification timestamp must fit in nine base36 characters')
  }
  return createdAtMs.toString(36).padStart(9, '0')
}

export function notificationCreatedAtFromId(id: string): number | undefined {
  const match = /^Notification\.([0-9a-z]{9})\.[A-Za-z0-9_-]+(?![\s\S])/.exec(id)
  if (isNotDefined(match)) return undefined
  return Number.parseInt(match[1], 36)
}
